var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"l-image-container",style:({ 'overflow-y': _vm.isScroll ? 'auto' : 'hidden' })},[_c('img',{staticClass:"l-image",style:({ 'height': _vm.isScroll ? 'auto' : '100%' }),attrs:{"src":_vm.url}})])
}
var staticRenderFns = []

export { render, staticRenderFns }